module.exports = __webpack_public_path__ + "img/ai.11f52d85.svg";